/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SchemaType,
    SchemaTypeFromJSON,
    SchemaTypeFromJSONTyped,
    SchemaTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface NewSchemaSubject
 */
export interface NewSchemaSubject {
    /**
     * 
     * @type {string}
     * @memberof NewSchemaSubject
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof NewSchemaSubject
     */
    schema: string;
    /**
     * 
     * @type {SchemaType}
     * @memberof NewSchemaSubject
     */
    schemaType: SchemaType;
}

export function NewSchemaSubjectFromJSON(json: any): NewSchemaSubject {
    return NewSchemaSubjectFromJSONTyped(json, false);
}

export function NewSchemaSubjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewSchemaSubject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'schema': json['schema'],
        'schemaType': SchemaTypeFromJSON(json['schemaType']),
    };
}

export function NewSchemaSubjectToJSON(value?: NewSchemaSubject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subject': value.subject,
        'schema': value.schema,
        'schemaType': SchemaTypeToJSON(value.schemaType),
    };
}

